import { Chip, Tooltip } from '@cavela/ui';

import { Typography } from '../ui';

const DEFAULT_POP_OVER_TEXT =
  'Projected date — may adjust depending on real-time progress.';

interface ExpectedTagProps {
  popOverText?: string;
}

const ExpectedTag: React.FC<ExpectedTagProps> = ({
  popOverText = DEFAULT_POP_OVER_TEXT
}) => {
  return (
    <Tooltip
      closeDelay={0}
      className="rounded-lg shadow-md font-medium text-base"
      content={popOverText}
    >
      <Chip
        color="default"
        className="bg-white border border-gray-4 rounded-lg !px-[6px] !h-6"
        classNames={{ content: '!p-0' }}
      >
        <Typography variant="body-3" className="text-secondary-text">
          Expected
        </Typography>
      </Chip>
    </Tooltip>
  );
};

export default ExpectedTag;
